import React, { Component } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import { Transition } from 'react-transition-group';

import style from './index.module.scss';

export default class Answer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.animateIn = this.animateIn.bind(this);
    this.animateOut = this.animateOut.bind(this);
  }

  getIndicator() {
    const { idx } = this.props;

    return <div className={`answer-${idx} ${style['indicator-icon']}`} ref={instance => this.indicator = instance}>{['A', 'B', 'C', 'D'][idx]}</div>;
  }

  animateIn() {
    this.tl.play();
    this.setState(() => ({ active: true }));
  }

  animateOut() {
    this.tl.reverse();
  }

  handleMouseEnter() {
    const { show, secondaryColor } = this.props;
    const { active } = this.state;
    if (!active || !show) return;

    this.setState(() => ({ hovered: true }));
    TweenMax.to(this.text, 0.5, { css: { textDecoration: 'underline' }});
    TweenMax.to(this.answer, 0.5, { css: { background: secondaryColor }});
  }

  handleMouseLeave(override = false) {
    const { active } = this.state;
    if (!active && !override) return;

    this.setState(() => ({ hovered: false }));
    TweenMax.to(this.text, 0.5, { css: { textDecoration: 'none' }});
    TweenMax.to(this.answer, 0.5, { css: { background: 'transparent' }});
  }

  componentDidMount() {
    const { index } = this.props;

    TweenMax.set(`.answer-${index}`, { drawSVG: 0 });
    this.tl = new TimelineMax({ paused: true });
    this.tl.to(`.answer-${index}`, 1, { drawSVG: '0 100%' });
  }
  
  render() {
    const { text, index, primaryColor, show, onClick } = this.props;

    return (
      <Transition
        timeout={0}
        in={show}
        onEnter={() => this.setState(() => ({ active: false }))}
        addEndListener={(node, done) => {
          show ? this.animateIn() : this.animateOut();
        }}
      >
        <div className={style.answer} ref={instance => this.answer = instance}
          style={{ color: primaryColor }} data-role="answer"
          onMouseDown={this.handleMouseEnter}
          onMouseOver={this.handleMouseEnter}
          onMouseOut={this.handleMouseLeave}
          onClick={() => onClick(index, text)}>
          <div className={style.indicator} ref={instance => this.indicator = instance}>
            {this.getIndicator()}
          </div>
          <div className={style.text} ref={instance => this.text = instance}>{text}</div>
        </div>
      </Transition>
    )
  }
}
